import type { OverviewMetrics } from "../types/api";
import { MetricCard } from "./MetricCard";

interface MetricsDashboardProps {
  metrics: OverviewMetrics;
}

export function MetricsDashboard({ metrics }: MetricsDashboardProps) {
  const avgCostPerEmail =
    metrics.totalGenerations > 0 ? metrics.totalCostUsd / metrics.totalGenerations : 0;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      <MetricCard label="Total Generations" value={metrics.totalGenerations} />
      <MetricCard
        label="Satisfaction Rate"
        value={`${(metrics.satisfactionRate * 100).toFixed(1)}%`}
      />
      <MetricCard label="Failure Rate" value={`${(metrics.failureRate * 100).toFixed(1)}%`} />
      <MetricCard label="Total Cost (USD)" value={`$${metrics.totalCostUsd.toFixed(2)}`} />
      <MetricCard label="Avg Cost / Email" value={`$${avgCostPerEmail.toFixed(4)}`} />
      <MetricCard label="Avg Latency" value={`${metrics.avgLatencyMs.toFixed(0)}ms`} />
      <MetricCard label="Total Likes" value={metrics.totalLikes} />
      <MetricCard label="Total Dislikes" value={metrics.totalDislikes} />
    </div>
  );
}
